import { Typography } from "@mui/material";
import constants from "../utils/constants";

function PageHeading({ text, mb }) {
  return (
    <Typography variant="h6" sx={{ color: constants.DARK, marginBottom: mb }}>
      {text}
    </Typography>
  );
}

export default PageHeading;
